module.exports = __webpack_public_path__ + "img/Jump Casting31.b882fbfb.jpg";